<div class="content-wrapper d-print-none">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Requests</h4>
          <div class="input-group-append">
            <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
          </div>
          <div class="table-responsive pt-3">
            <nz-table #contractTable [nzData]="adhocs" [nzPageSize]="50">
              <thead>

                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Reference
                  </th>

                  <th>
                    Requester Name
                  </th>

                  
                  <th>
                    Employee Name
                  </th>

                  <th>
                    Employee Function
                  </th>

                  <th>
                    Employee Location
                  </th>

                  <th>
                    Status
                  </th>
                  <th>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of contractTable.data; let i = index ;" >

                  <td>
                    {{i+1}}
                  </td>
                  <td>
                    {{ data.reference }} 
                  </td>

                  <td>
                    {{data.requesterName}}
                  </td>

                 

                  <td>
                    {{data.employeeName}}
                  </td>

                  <td>
                    {{data.employeeFunction}}
                  </td>

                  <td>
                    {{data.employeeLocation}}
                  </td>

                  <td>
                    <button [ngClass]="getStatusColor(data.status)"> {{data.status}}</button>
                  </td>
                  <td>
                    
                    <div class="dropdown">
                      <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuIconButton6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                       
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">
               
                        <a class="dropdown-item" (click)="open(data)">View</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" (click)="openPendingApprovals(data)">View Approvals</a>
                            <div class="dropdown-divider"></div>
                      </div>
                    </div>

                
                  </td>
                </tr>
              </tbody>
            </nz-table>

          </div>
        </div>
      </div>
    </div>


  </div>
</div>
<!-- Context Menu  -->
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item>1st menu item</li>
    <li nz-menu-item>2nd menu item</li>
    <li nz-menu-divider></li>
  </ul>
</nz-dropdown-menu>


<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="row">
          <div  class="col">
            <h5 class="card-title"> Job Rotation Details</h5>
          </div>
          <div  class="col">
            <img src="../../../assets/images/holcim_logo_color.svg" alt=""
            srcset="" style="height: 30px;">
          </div>
        </div>
      
       
        <div class="card-body">
          <div class="row">
            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ UpdateRequest?.reference }}</p>
            </div>

            <div class="col">
              <label><b>Requester Name</b></label>
              <p>{{ UpdateRequest?.requesterName }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Requester Designation</b></label>
              <p>{{ UpdateRequest?.requesterDesignation }}</p>
            </div>

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>
          </div>
        </div>

        <hr *ngIf="!editing">

        <!-- Non Editable View -->
        <div class="card-body" *ngIf="!editing">
          
          <div class="row">
            <div class="col">
              <label><b>Employee Name</b></label>
              <p>{{ UpdateRequest?.employeeName }}</p>
            </div>

            <div class="col">
              <label><b>Employee Function</b></label>
              <p>{{ UpdateRequest?.employeeFunction }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Current Location</b></label>
              <p>{{ UpdateRequest?.employeeLocation}}</p>
            </div>

            <div class="col">
              <label><b>Current Unit</b></label>
              <p>{{ UpdateRequest?.employeeUnit }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b> Current Designation</b></label>
              <p>{{ UpdateRequest?.employeeCurrentDesignation }}</p>
            </div>

             
          </div>

          <div class="row">
            <div class="col">
              <label><b>Current Manager</b></label>
              <p>{{ UpdateRequest?.currentManager}}</p>
            </div>

            <div class="col">
              <label><b>Current Head of Unit</b></label>
              <p>{{ UpdateRequest?.currentUnitHead }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label><b>Rotation Start Date</b></label>
                <p>{{ UpdateRequest?.rotationStartDate | date: 'dd MMMM yyyy'}}</p>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label><b>Rotation End Date</b></label>
                <p>{{ UpdateRequest?.rotationEndDate | date: 'dd MMMM yyyy'}}</p>
              </div>
            </div>
          </div>

          <div class="row" *ngIf = "UpdateRequest?.currentSection">
            <div class="col">
              <label><b>Current Section</b></label>
              <p>{{ UpdateRequest?.currentSection}}</p>
            </div>
          </div>

          <hr>

          <div class="row">
            <div class="col">
              <label><b>Receiving Function</b></label>
              <p>{{ UpdateRequest?.receivingFunction}}</p>
            </div>

            <div class="col">
              <label><b>Receiving Unit</b></label>
              <p>{{ UpdateRequest?.receivingUnit }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Receiving Location</b></label>
              <p>{{ UpdateRequest?.receivingLocation}}</p>
            </div>

            
          </div>

          <div class="row" *ngIf = "UpdateRequest?.newSection">
            <div class="col">
              <label><b>New Section</b></label>
              <p>{{ UpdateRequest?.newSection}}</p>
            </div>
          </div>
          
        </div>

        <hr>

        <!-- Approvals -->
        <div class="card-body" *ngIf="!editing">
          <h5 class="card-title">Approvals</h5>
          <div class="table-responsive" *ngIf="RequestApprovals?.length">
            <table class="table table--striped table-hover">
              <thead>
                <tr>

                  <th>
                    Approved By
                  </th>
                  <th>
                    Designation
                  </th>
                  <th>
                    Status
                  </th>
                  <th>
                    Date Approved
                  </th>
                  <th>
                    Message
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let approval of RequestApprovals">

                  <td>{{approval.name}}</td>
                  <td>{{approval.designation }}</td>
                  <td>{{approval.status}}</td>
                  <td>{{approval.approvalDate | date: 'dd MMMM yyyy hh:mm a'}}</td>
                  <td>{{approval.message}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="!RequestApprovals?.length"
            style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
            <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
          </div>
          <!-- Approvals -->
        </div>
        <!-- Non Editable -->

        <!-- Editable view -->
        <div class="card-body d-print-none" *ngIf="canUpdatePO">

          <div class="row">

            <div class="col">
              <div class="form-group">
                <label><b>PO Number</b></label>
                <input type="text" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  class="form-control" id="poEntry" name="poEntry" [(ngModel)]="poEntry" minlength="4" maxlength="10">
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label><b>Contractor</b></label>
                    <ng-select  required [(ngModel)]="contractorId"  id="contractorId" name="contractorId">
                      <ng-option aria-valuetext="">select contractor</ng-option>
                  <ng-option *ngFor="let vendor of Vendors" [value]="vendor.id">
                    <!-- {{vendor.name}} - {{vendor.contractorType}}</ng-option> -->
                    {{vendor.name}} </ng-option>

                </ng-select>


              </div>
            </div>

          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label><b>Approved Cost</b></label>
                <input type="number" class="form-control" id="approvedCost" name="approvedCost"
                  [(ngModel)]="approvedCost">
              </div>
            </div>
              <!-- Expected Start Date  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Actual Start Date</label>
                  <input type="date" class="form-control" id="actualStartDate" placeholder="" name="actualStartDate"
                    min="{{ actualStartDate | date: 'yyyy-MM-dd' }}" [(ngModel)]="actualStartDate" required
                    #ActualStartDate="ngModel">
                  <div class="alert alert-danger" role="alert"
                    *ngIf="ActualStartDate.errors">
                    Date is required!
                  </div>
                </div>
              </div>
           
<!--
            <div class="col">
              <div class="form-group">
                <label><b>Biometrics Required?</b></label>
                <select class="form-control" required [(ngModel)]="biometricRequired" name="biometricRequired">
                  <option [ngValue]="false">No</option>
                  <option [ngValue]="true">Yes </option>
                </select>
              </div>
            </div>
          -->
          </div>

          <div class="row">
<!--
            <div class="col">
              <div class="form-group">
                <label><b>Medical Requirement</b></label>
                <textarea class="form-control" id="medicalNotes" rows="4" name="medicalNotes" [(ngModel)]="medicalNotes"
                  required> </textarea>
              </div>
            </div>
 -->
            <div class="col">
              <div class="form-group">
                <label><b>Safety Requirement</b></label>
                <textarea class="form-control" id="safetyInductionNotes" rows="4" name="safetyInductionNotes"
                  [(ngModel)]="safetyInductionNotes" required> </textarea>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">PO Date</label>
                <input type="date" class="form-control" id="poDate" placeholder="" name="poDate"
                  min="{{ poDate | date: 'yyyy-MM-dd' }}" [(ngModel)]="poDate" required
                  #PoDate="ngModel">
                <div class="alert alert-danger" role="alert"
                  *ngIf="PoDate.errors">
                  Date is required!
                </div>
              </div>
            </div>

          </div>

       
          
          <!-- Editable View -->

        </div>
      </div>
    </div>
    <!-- Side swipe content -->

    <ng-template #footerTpl>
      <div style="float: right" class="d-print-none">

        <button class="btn btn-primary" style="margin-right: 8px;" (click)="print()"
          *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active'">Print</button>

        <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;"
          (click)="close()">Close</button>
      </div>

      <!-- Terminate Request  
      <div style="float: left" class="d-print-none">
        <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
          (nzOnConfirm)="openTerminate()" (nzOnCancel)="cancel()">
          <span style="margin-right: 8px;" class="btn btn-danger"
            *ngIf="canTerminate">
            Terminate Request
          </span>
        </a>
      </div>
-->
      <div style="float: right" class="d-print-none"   *ngIf="canChangeEmp && UpdateRequest?.status === 'Active'">
        <a nz-popconfirm nzPopconfirmTitle="Are you sure? This will require approvals!" nzOkText="Yes"
          nzCancelText="Cancel" (nzOnConfirm)="openChangeNoModal()" (nzOnCancel)="cancel()">
          <span style="margin-right: 8px;" class="btn btn-dark btn-icon-text">
            Change No of Employees
            <i class="ti-file btn-icon-append"></i>  
          </span>
        </a>
      </div>

    </ng-template>
  </div>
</nz-drawer>

<!-- Change Number of Employee Modal  -->
<nz-modal [(nzVisible)]="isChangeNumVisible" nzTitle="Change Number of Employees" (nzOnCancel)="handleCancel()"
  (nzOnOk)="submitForm()" [nzOkLoading]="isChangeOkLoading">
  <form nz-form [formGroup]="newNumOfStaffForm" (ngSubmit)="submitForm()">

    <div class="row">

      <div class="col">
        <label><b>Current Approved Number </b></label>
        <p>{{ UpdateRequest?.noOfStaff  }}</p>
      </div>

      <div class="col">
        <label><b> Active Number of Employees</b></label>
        <p>{{ UpdateRequest?.numberofActiveEmployees }}</p>
      </div>
    </div>

    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzFor="numberOfStaff" nzRequired nzTooltipTitle="New Number of Employees">
        <span>Number of Staff</span>
      </nz-form-label>
      <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please enter No of Staff!">
        <input nz-input id="numberOfStaff" formControlName="numberOfStaff" class="formControl" type="number" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzFor="message" nzRequired nzTooltipTitle="Comment is mandatory">
        <span>Comment</span>
      </nz-form-label>
      <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please enter Comment!">

        <textarea formControlName="message" nz-input rows="2" placeholder="Comment" class="formControl"></textarea>
      </nz-form-control>
    </nz-form-item>


     
  </form>




</nz-modal>

<!-- Express Approval  Modal  -->
<nz-modal [(nzVisible)]="isExpressApprovalModalVisible" nzTitle="Express Approval" (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification">Comment</label>
      <textarea class="form-control" id="expressApprovalMessage" rows="4" name="expressApprovalMessage"
        [(ngModel)]="expressApprovalMessage" required></textarea>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="sendExpressApproval()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>

<!-- Close Request Modal  -->
<nz-modal [(nzVisible)]="isTerminationVisible" nzTitle={{terminateTitle}} (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Comment</b></label>
      <textarea class="form-control" id="terminationComment" name="terminationComment" [(ngModel)]="terminationComment"
        required>
      </textarea>
    </div>

  
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-danger" (click)="terminateRequest()" [disabled]="isChangeOkLoading">Terminate</button>
  </div>

</nz-modal>



<!-- Renew Contract modal  -->
<nz-modal [(nzVisible)]="isReneweModalVisible" nzTitle={{renewModalTitle}} (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Duration (Months)</b></label>
      <input  type="number" class="form-control" id="renewDuration" name="renewDuration" [(ngModel)]="renewDuration" required   (ngModelChange)="onchangeforEndDate($event)">
    </div>
  

    <div class="form-group">

      <label for="exampleInputCity1"><b>Start Date</b></label>
      <input type="date" class="form-control" id="renewStartDate" placeholder="" name="renewStartDate"  (ngModelChange)="onchangeforEndDate($event)"
        [(ngModel)]="renewStartDate" required>
    </div>

    <!-- 
    <div class="form-group">
      <label for="exampleInputCity1"><b>End Date </b></label>
      <input type="text" class="form-control" id="renewEndDate" placeholder="" name="renewEndDate" readonly
        [(ngModel)]="renewEndDate" required>
    </div>
-->

    <div class="form-group">
      <label for="exampleInputCity1"><b>Comments</b></label>
      <input type="text" class="form-control" id="renewComment" placeholder="" name="renewComment"
        [(ngModel)]="renewComment" required>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="sendRenewRequest()" nz-button [nzLoading]="isLoadingRenew">Submit</button>
  </div>

</nz-modal>


<!-- Cancel Request Modal  -->
<nz-modal [(nzVisible)]="isCancelVisible" nzTitle="Cancel Request" (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Comment</b></label>
      <textarea class="form-control" id="cancelComment" name="cancelComment" [(ngModel)]="cancelComment"
        required>
      </textarea>
    </div>

  
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-danger" (click)="cancelRequest()" [disabled]="isChangeOkLoading">Cancel Request</button>
  </div>

</nz-modal>

 <!-- View Pending Request Approval Modal  -->
 <nz-modal [(nzVisible)]="isContractpprovalModalVisible" nzTitle="Request Approvals"[nzWidth]="800" (nzOnOk)="handleCancel()" [nzCancelText]="null">

  <div *nzModalContent>
   
    <div class="table-responsive">
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Name
            </th>
            <th>
              Designation
            </th>
            <th>
              Status
            </th>
          
            <th>
              Approval Date
            </th>

            <th>
              Comment
            </th>
          

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of ContractRequestApprovals">

            <td>{{approval.name}}</td>
            <td>{{approval.designation }}</td>
            <td>{{approval.status}}</td>
            <td>{{approval.approvalDate | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

 
</nz-modal>